export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14805.fed1b066.jpg";